import axios from "axios";
import { config } from "../../Utils/helpers";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const sendEmailNotification = (emailNotificationPayload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "SEND_EMAIL_NOTIFICATION_REQUEST" });
            const { data } = await axios.post(
                `${BASE_URL}/notifications/send-all-user-email`,
                emailNotificationPayload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({ type: "EMAIL_NOTIFICATION_SEND_SUCCESS", payload: data });
                return { success: true }
            } else {
                dispatch({ type: "EMAIL_NOTIFICATION_SEND_FAILURE", payload: data });
                return { success: false }
            }
        } catch (error) {
            dispatch({ type: "EMAIL_NOTIFICATION_SEND_FAILURE", payload: error.response });
            return { success: false }
        }
    };
};

export const getUserData = (type) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "GET_USER_REQUEST" });
            const { data } = await axios.post(
                `${BASE_URL}/notifications/sender-list`,
                type,
                config
            );

            if (data.statusCode === 200) {
                dispatch({ type: "GET_USER_SUCCESS", payload: data });
            } else {
                dispatch({ type: "GET_USER_FAILURE", payload: data });
            }
        } catch (error) {
            dispatch({ type: "GET_USER_FAILURE", payload: error.response });
        }
    };
}

export const scheduleEmail = (notificationPayload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "SCHEDULE_EMAIL_REQUEST" });
            const { data } = await axios.post(
                `${BASE_URL}/notifications/email-schedule`,
                notificationPayload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({ type: "SCHEDULE_EMAIL_SUCCESS", payload: data });
                return { success: true }
            } else {
                dispatch({ type: "SCHEDULE_EMAIL_FAILURE", payload: data });
                return { success: false }
            }
        } catch (error) {
            dispatch({ type: "SCHEDULE_EMAIL_FAILURE", payload: error.response });
            return { success: false }
        }
    };
};